<script>
  // @ts-check
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Types from "./newsLetterTypes";

  import NewsletterFormView from "./NewsletterFormView.svelte";
  // @ts-ignore
  import NewsletterConfirmationView from "./NewsletterConfirmationView.svelte";
  import { getTheme } from "../../utilities";

  /** Primarily used for testing
   * @type {string} */
  export let id = "";

  /** The type of layout under the featured layout
   * @type { "vertical" | "horizontal" }
   */
  export let layoutVariant = "horizontal";

  /**
   * The theme of the hero section
   * @type {import('../../utilities/themes.js').ThemeName}
   */
  export let theme = "lightGrey";

  /**
   * The featured image in the card
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage = undefined;

  /** The title of the NewsLetter component
   * @type {string} */
  export let title = undefined;

  /**
   * The description of the NewsLetter component
   * @type {string}
   */
  export let description = null;

  /** The title of the NewsLetter Confirmation component
   * @type {string} */
  export let titleConfirmationPage = undefined;

  /** The title of the NewsLetter Confirmation component
   * @type {string} */
  export let subTitleConfirmationPage = undefined;

  /**
   * The description of the NewsLetter Confirmation component
   * @type {string}
   */
  export let descriptionConfirmationPage = null;

  /**
   * The call to action of the NewsLetter Confirmation component
   * @type {import('../../types/shared.js').CTA}
   */
  export let cta = null;

  /** @type {string} */

  /**
   * optional prop for handling form submission natively
   *
   * @type {Types.FormProps}
   * */
  export let formProps;

  /**
   * The formFields props.
   * @type {Types.FormFieldsProps}
   */
  export let formFields = undefined;

  /**
   * Indicates whether the form submission was successful
   * @type {boolean}
   */
  export let isFormSubmitSuccess = false;

  /**
   * Indicates whether the form is currently being submitted
   * @type {boolean}
   */
  export let isSubmitting = false;

  export let onSubmit = () => undefined;

  /**
   * The error message to display when the form submission fails
   * @type {string}
   */
  export let formSubmitErrorMessage = undefined;

  const hasFeatureImage = !!featuredImage?.src && !!featuredImage?.alt;

  $: currentTheme = getTheme(theme);
  $: containerClass = !hasFeatureImage
    ? `${currentTheme?.backgroundColor} gap-0 lg:gap-[4.5rem] px-2 py-8 md:px-10 md:py-14 lg:p-12.5 xl:p-15 h-full lg:min-h-[37.25rem] xl:min-h-[46.5rem]`
    : `${currentTheme?.backgroundColor} gap-0 lg:gap-9 xl:gap-[4.5rem] pt-2 pb-8 px-2 md:px-3 md:pb-12.5 md:pt-3 lg:p-3 xl:p-4 lg:pr-0 lg:pr-9 xl:pr-[4.5rem]`;

  let descriptionClass = "body-md pt-4 pb-0 md:pb-0 md:py-5 lg:py-5 xl:py-7";

  let contentClass = !hasFeatureImage
    ? "px-5 py-0 md:px-3 lg:px-0 lg:py-6 xl:py-8"
    : "px-5 pt-6 md:px-10 lg:px-0 lg:px-0 md:pt-15 md:pt-6 xl:pt-8";

  const transitionFadeInClass = "transition-all duration-[400ms] input-easing animate-fadeIn";

  const visibleClasses = "visible opacity-opaque";
  const invisibleClasses = "invisible opacity-transparent pointer-events-none hidden";
  $: confirmationVisibilityClasses = isFormSubmitSuccess ? visibleClasses : invisibleClasses;
  $: formVisibilityClasses = isFormSubmitSuccess ? invisibleClasses : visibleClasses;
</script>

<div {id} class="relative w-full">
  <div
    aria-hidden={!isFormSubmitSuccess}
    class="inset-0 z-[--stack-level-newsletter-confirmation] h-fit w-full {transitionFadeInClass} {confirmationVisibilityClasses}"
  >
    <NewsletterConfirmationView
      id="newsletter-confirmation-view"
      title={titleConfirmationPage}
      subTitle={subTitleConfirmationPage}
      description={descriptionConfirmationPage}
      {featuredImage}
      {containerClass}
      {contentClass}
      {cta}
      {isFormSubmitSuccess}
    />
  </div>

  <div class="w-full {transitionFadeInClass} visible {formVisibilityClasses}">
    <NewsletterFormView
      id={`form-view-${id}`}
      {layoutVariant}
      {title}
      {description}
      {featuredImage}
      {containerClass}
      {contentClass}
      {descriptionClass}
      {isSubmitting}
      {formSubmitErrorMessage}
      {formProps}
      {formFields}
      {onSubmit}
    />
  </div>
</div>
